import {useTheme} from "@src/features/settings/contexts/theme-provider";
import type {Theme} from "@src/features/settings/settings-models";
import {Button} from "@src/ui/views/button";
import {DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,} from "@src/ui/views/dropdown-menu";
import {Tooltip, TooltipContent, TooltipTrigger} from "@src/ui/views/tooltip";
import {Moon, Sun} from "lucide-react";
import * as React from "react";


const THEME_TO_NAME: Record<Theme, string> = {
	light: "Light",
	dark: "Dark",
	system: "System",
};


type ThemeItemProps = {
	theme: Theme
}


export function ThemeToggle() {
	return (
		<DropdownMenu>
			<Tooltip>
				<TooltipTrigger asChild>
					<DropdownMenuTrigger asChild>
						<Button variant="ghost" size="icon" className="rounded-full overflow-clip">
							<Sun
								className="h-[1.2rem] w-[1.2rem] rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0"/>
							<Moon
								className="absolute h-[1.2rem] w-[1.2rem] rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100"/>
							<span className="sr-only">Toggle theme</span>
						</Button>
					</DropdownMenuTrigger>
				</TooltipTrigger>
				<TooltipContent>
					<p>Toggle theme</p>
				</TooltipContent>
			</Tooltip>
			<DropdownMenuContent align="end" className="min-w-[6rem]">
				<ThemeItem theme="light"/>
				<ThemeItem theme="dark"/>
				<ThemeItem theme="system"/>
			</DropdownMenuContent>
		</DropdownMenu>
	);
}


function ThemeItem(props: ThemeItemProps) {
	const {theme, setTheme} = useTheme();
	
	const themeName = THEME_TO_NAME[props.theme];
	
	if (props.theme === theme) {
		return (
			<DropdownMenuItem
				className="italic font-semibold hover:font-bold"
				onClick={() => setTheme(props.theme)}
			>
				{themeName}
			</DropdownMenuItem>
		);
	}
	
	return (
		<DropdownMenuItem
			className="hover:font-semibold"
			onClick={() => setTheme(props.theme)}
		>
			{themeName}
		</DropdownMenuItem>
	);
}
